import { Box, Typography } from '@mui/material'
import React, { useState } from 'react'
import TextBox from '../../components/TextBox'
import { Add, CalendarMonth, Percent } from '@mui/icons-material'
import CustomSwitch from '../../components/CustomSwitch'
import ButtonSubmit from '../../components/ButtonSubmit'
import API from '../../services/api'
import { useNavigate } from 'react-router-dom'
import CustomSnackBar from '../../components/CustomSnackBar'

export default function CreateEPayment({ supplier, setOpen, onClose, data }) {
  const [openSnack, setOpenSnack] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [snackMessage, setSnackMessage] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("info");
  const [ep, setEp] = useState({
    datePeriod: 0,
    percent: 0,
    dueDateInvoice: true,
    supplier: supplier
  })

  const handleChange = (name, value) => {
    setEp({
      ...ep, [name]: value
    })
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await API.post("early-payment/", ep);

      setOpenSnack(true);
      setSnackMessage("¡Creado con éxito!");
      setSnackSeverity("success");
      setTimeout(() => {
        setLoading(true);
         onClose();
         data()
      }, 1500)


    } catch (error) {
      setOpenSnack(true);
      console.log(error);
      setSnackMessage("Intente de nuevo");
      setSnackSeverity("error");
      setLoading(false);
    }
  }
  return (
    <form onSubmit={handleSubmit}>
      <TextBox
        label='Periodo (dias)'
        icon={CalendarMonth}
        type='number'
        maxLength={2}
        required
        onChange={handleChange}
        errorMessage='Campo requerido'
        name={'datePeriod'}
      />
      <TextBox
        label='Porcentaje'
        icon={Percent}
        type='number'
        maxLength={5}
        required
        onChange={handleChange}
        errorMessage='Campo requerido'
        name={'percent'}
      />
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        mt: 2 // Margen superior opcional
      }}>
        <CustomSwitch
          label={'Fecha factura'}
          name={'dueDateInvoice'}
          onChange={handleChange}
        />
      </Box>

      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        mt: 2 // Margen superior opcional
      }}>
        <ButtonSubmit
          icon={Add}
          name='Agregar'
          loading={loading}
          color='primary'
          sx={{ width: '100%', maxWidth: 200 }} // Ajusta el ancho máximo según necesites
        />
      </Box>

      {openSnack && (
        <CustomSnackBar open={openSnack} setOpen={setOpenSnack} message={snackMessage} severity={snackSeverity} loading={loading} />
      )}
    </form>
  )
}
